export default __webpack_public_path__ + "static/media/warning.026c1ebe.svg";